import { createSelector } from 'reselect';

import { getState as getParent, getLockersByIds } from './index';
import { getSelectedDealerId } from '../../../selectors/dealerSelectors';

const getRoot = state => state;

const getProps = (_, props) => props;

const getState = createSelector(getParent, state => state.ui.dashboard);

export const getFilters = createSelector(getState, state => state.filters);

export const getPage = createSelector(getState, state => state.page);

export const hasNextPage = createSelector(getPage, ({ number: page = 0, totalPages: pages = 0 }) => page + 1 < pages);

export const getParams = createSelector(
  getFilters,
  getSelectedDealerId,
  getPage,
  (filters, dealerId, { size = 5 }) => ({
    ...filters,
    dealerId,
    size,
  })
);

const getIds = createSelector(getState, state => state.ids);

export const getSelectedDealerLockers = createSelector(getRoot, getIds, getLockersByIds);

export const haveLockers = createSelector(getPage, page => page.totalElements > 0);

export const isLoading = createSelector(getState, state => state.isLoading);

export const isDeleting = createSelector(getState, getProps, (state, lockerId) => state.isDeleting === lockerId);
